export { FourOhFour as default } from '../compositions';
